import { GENERATE_OTP_REQUEST, LOGIN_REQUEST, LOGOUT, REFRESH_TOKEN_REQUEST } from "./constants";

export function generateOTP(data: any) {
  return {
    type: GENERATE_OTP_REQUEST,
    payload: {
      method: "POST",
      url: "/auth/login/otp/generate",
      data,
    },
  };
}

export function login(data: any) {
  return {
    type: LOGIN_REQUEST,
    payload: {
      method: "POST",
      url: "/auth/login/otp",
      data,
    },
  };
}

export function logout() {
  return {
    type: LOGOUT,
  };
}

export function refresh(refreshToken: string) {
  return {
    type: REFRESH_TOKEN_REQUEST,
    payload: {
      method: "POST",
      url: "/auth/refresh",
      data: { refresh: refreshToken },
    },
  };
}
